import { Button, Form, Input, Modal, Spin } from "antd";
import { useForm } from "antd/es/form/Form";
import axios from "axios";
import { useState } from "react";
import agblack from "./Images/agblack.png";

const ResetPassword = () => {
  const [isLoading, setLoading] = useState(false);
  const [form] = useForm();

  const searchParams = new URLSearchParams(window.location.search);
  const token = searchParams.get("token");
  const email = searchParams.get("email");

  const baseUrl = process.env.REACT_APP_SSO_API;

  const onFinish = (values) => {
    setLoading(true);
    axios
      .post(
        `${baseUrl}reset-password/${token}`,
        {
          email: email,
          password: values.password,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        success(response?.data?.success);

        setTimeout(() => {
          window.location.replace("/");
        }, 2000);
      })
      .catch((error) => {
        setLoading(false);
        warning(error.response.data.error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const warning = (message) => {
    Modal.error({
      title: "Validation Error!",
      content: message,
    });
  };

  const success = (message) => {
    Modal.success({
      title: "Success!",
      content: message,
    });
  };

  const onFinishFailed = (values) => {
    console.log("Success:", values);
  };

  const passwordVaildator = (_, value) => {
    if (!value) {
      return Promise.reject(new Error("Please input your password"));
    }

    if (value.length < 8) {
      return Promise.reject(new Error("Password must be at least 8 characters"));
    }

    if (!/[A-Z]/.test(value)) {
      return Promise.reject(
        new Error("Password must contain at least one uppercase letter")
      );
    }

    if (!/[!@#$%^&*]/.test(value)) {
      return Promise.reject(
        new Error("Password must contain at least one special character")
      );
    }
    return Promise.resolve();
  };

  const passwordMatch = (_, value) => {
    if (!value) {
      return Promise.reject(new Error("Please confirm your password"));
    }

    if (value && value !== form.getFieldValue("password")) {
      return Promise.reject(new Error("The passwords do not match"));
    }

    return Promise.resolve();
  };

  return (
    <Spin spinning={isLoading}>
        <div className="rebrand-forgot-main">
          <div className="rebrand-forgot-main-wrapper rebrand-reset-main-wrapper">
            <div className="rebrand-forgot-img">
              <img src={agblack} alt="" />
            </div>
            <div className="rebrand-forgot-form">
              <h2>Reset Password</h2>
              <Form
                form={form}
                name="basic"
                layout="vertical"
                initialValues={{
                  remember: true,
                }}
                autoComplete="off"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
              >
                <Form.Item
                  label="Password"
                  name="password"
                  rules={[{ required: true, validator: passwordVaildator }]}
                >
                  <Input.Password />
                </Form.Item>

                <Form.Item
                  label="Confirm Password"
                  name="confirm_password"
                  dependencies={["password"]}
                  rules={[{ required: true, validator: passwordMatch }]}
                >
                  <Input.Password />
                </Form.Item>

                <Form.Item>
                  <Button type="primary" htmlType="submit">
                    Submit
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </div>
        </div>
    </Spin>
  );
};

export default ResetPassword;
